export default "https://cdn-static.gokick.com/assets/7618e3e921e472ff268b4a806e404f75ad5d1010/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";